import { useAppSelector } from "redux/hooks";
import {
  selectAllSystemPageLabelGroups,
  selectLensEditorLens,
  selectSystemPageLabelGroups,
  setSystemPageLabelGroupsForLens,
} from "redux/slices/lensEditor";
import {
  Box,
  Button,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import { HelpIconOutlined } from "components/CustomIcons";
import { useState } from "react";
import { SystemPageLabelGroupView } from "generated/graphql";
import useAppDispatchWithSnackbar from "helpers/hooks/useAppDispatchWithSnackbar";
import { P } from "theme/typography";

const SystemPageLabels = () => {
  const pageLabelGroups = useAppSelector(selectSystemPageLabelGroups);
  const allSystemPageLabelGroups = useAppSelector(selectAllSystemPageLabelGroups);
  const [canSave, setCanSave] = useState(false);
  const [checked, setChecked] = useState<SystemPageLabelGroupView[]>([...pageLabelGroups]);
  const lens = useAppSelector(selectLensEditorLens);
  const snackpatch = useAppDispatchWithSnackbar();

  const handleToggle = (value: SystemPageLabelGroupView) => () => {
    const currentIndex = checked.findIndex((p) => p.group === value.group);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    setChecked(newChecked);
    setCanSave(true);
  };

  const save = () => {
    return snackpatch(setSystemPageLabelGroupsForLens({ lensId: lens.id, labelGroups: checked }), {
      successMessage: "System Page Labels updated",
      errorMessage: "Unable to update System Page Labels",
    }).then(() => {
      setCanSave(false);
    });
  };

  return (
    <Box sx={{ display: "grid", gap: "16px 16px", gridTemplateColumns: "1fr 2fr", height: "100%", p: 1 }}>
      <Box sx={{ display: "flex", flexDirection: "column", height: "100%", minHeight: 0 }}>
        <TableContainer>
          <Table size="small" sx={{ mt: 1, tableLayout: "fixed" }} stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>Group Name</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {allSystemPageLabelGroups.map((plg) => {
                return (
                  <TableRow key={plg.group}>
                    <TableCell>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "left",
                          alignItems: "center",
                          ml: 1,
                        }}>
                        <P sx={{ mr: 1 }}>{plg.group}</P>
                        <Tooltip
                          title={
                            <span>
                              {plg.pageLabels.map((pl) => (
                                <P key={pl} sx={{ color: "white" }}>
                                  {pl}
                                </P>
                              ))}
                            </span>
                          }>
                          <HelpIconOutlined fontSize="small" />
                        </Tooltip>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Checkbox
                        edge="end"
                        onChange={handleToggle(plg)}
                        checked={checked.filter((p) => p.group === plg.group).length > 0}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
        <Button disabled={!canSave} color="primary" variant="contained" onClick={save}>
          Save
        </Button>
      </Box>
    </Box>
  );
};

export default SystemPageLabels;
